import { CatalogBrandsFilterValue } from '@/entities/catalog-brands/types/type'

export const getFilteredProperties = (items: CatalogBrandsFilterValue[], searchValue: string) =>
	items.filter(filterValue => {
		const incomingValue = filterValue.VALUE.toString().toLocaleLowerCase()
		const searchingValue = searchValue.toLocaleLowerCase()

		return incomingValue.includes(searchingValue)
	})
